// import { API } from 'aws-amplify';
import { get, post, put, del } from 'aws-amplify/api'

var myInitData = (data: any) => ({
  body: data,
})

// Helper function to convert Operation to Promise that returns parsed JSON
const toJsonPromise = async (operation: any) => {
  const response = await operation.response
  return await response.body.json()
}

export const POST_ENDPOINT = (endpoint: any, data: any) => toJsonPromise(post({ apiName: 'root', path: `${endpoint}`, options: myInitData(data) }))
export const GET_ENDPOINT = (endpoint: any) => toJsonPromise(get({ apiName: 'root', path: `${endpoint}` }))
export const PUT_ENDPOINT = (endpoint: any, id: any, data: any) => toJsonPromise(put({ apiName: 'root', path: `${endpoint}/${id}`, options: { body: data } }))
export const DELETE_ENDPOINT = (endpoint: any, id: any) => toJsonPromise(del({ apiName: 'root', path: `${endpoint}/${id}` }))
export const GET_UNIQUE_ENDPOINT = (endpoint: any, id: any) => toJsonPromise(get({ apiName: 'root', path: `${endpoint}/${id}` }))
